import React from 'react';
import {
    Card,
    FormLayout,
    TextField,
    Text
} from '@shopify/polaris';

export function AutoTagProductsByStatusSettings(props) {

    function handleActiveTagChange(value) {

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.statusActiveTag = value;
        props.onSettingsChange(newSettings);
    }
    
    function handleDraftTagChange(value) {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.statusDraftTag = value;
        props.onSettingsChange(newSettings);
    }
    
    function handleArchivedTagChange(value) {
        
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.statusArchivedTag = value;
        props.onSettingsChange(newSettings);
    }

    return (
        <React.Fragment>

            <Card.Section title="State Tags">
                <Text variant="bodyMd" as="p" color="warning">
                    Note: tags for previous states are cleared when product enters in new state.
                </Text>
                <br />
                <FormLayout>
                    <TextField
                        label="Tag for ACTIVE state"
                        placeholder="Tag name"
                        helpText={
                            <span>
                                Give a name to easily identify this custom product rule.
                            </span>
                        }
                        value={props.settings.statusActiveTag}
                        onChange={handleActiveTagChange}
                        autoComplete="off"
                    />
                    <TextField
                        label="Tag for DRAFT state"
                        placeholder="Tag name"
                        helpText={
                            <span>
                                Give a name to easily identify this custom product rule.
                            </span>
                        }
                        value={props.settings.statusDraftTag}
                        onChange={handleDraftTagChange}
                        autoComplete="off"
                    />
                    <TextField
                        label="Tag for ARCHIVED state"
                        placeholder="Tag name"
                        helpText={
                            <span>
                                Give a name to easily identify this custom product rule.
                            </span>
                        }
                        value={props.settings.statusArchivedTag}
                        onChange={handleArchivedTagChange}
                        autoComplete="off"
                    />
                </FormLayout>
            </Card.Section>
        </React.Fragment>
    );
}